module.exports = __webpack_public_path__ + "img/MemeETC (19).3b4e952d.jpeg";